import React from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Form } from "react-final-form";
import { SelectField } from "@syos-music/form";
import { Dialog } from "@syos-music/common";

import { Button, InputAdornment, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ArrowRight as ArrowIcon } from "mdi-material-ui";

const QUERY = gql`
  query {
    orderStates(withDeleted: false) {
      id
      label
    }
  }
`;

const MUTATION = gql`
  mutation ($fromOrderStateId: ID!, $toOrderStateId: ID!) {
    MoveAllOrders(
      fromOrderStateId: $fromOrderStateId
      toOrderStateId: $toOrderStateId
    ) {
      fromOrderState {
        id
      }
      toOrderState {
        id
      }
    }
  }
`;

export default function MoveAllOrdersDialog({ fromOrderState, onClose }) {
  const { data } = useQuery(QUERY);

  const [moveAllOrders] = useMutation(MUTATION);

  return (
    <Dialog open={Boolean(fromOrderState)} onClose={onClose}>
      <Form
        onSubmit={async ({ toOrderStateId }) =>
          moveAllOrders({
            variables: {
              fromOrderStateId: fromOrderState.id,
              toOrderStateId,
            },
          })
            .then(onClose)
            .catch(() => true)
        }
      >
        {({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit} noValidate autoComplete="off">
            <Dialog.Title color="primary">
              Déplacer toutes les commandes
            </Dialog.Title>

            <Dialog.Content>
              {fromOrderState && (
                <SelectField
                  name="toOrderStateId"
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {fromOrderState.label}
                        <ArrowIcon style={{ marginLeft: "0.5ch" }} />
                      </InputAdornment>
                    ),
                    step: 0.01,
                  }}
                >
                  {data?.orderStates.map((orderState) => (
                    <MenuItem
                      key={orderState.id}
                      value={orderState.id}
                      disabled={orderState.id === fromOrderState.id}
                    >
                      {orderState.label}
                    </MenuItem>
                  ))}
                </SelectField>
              )}
            </Dialog.Content>

            <Dialog.Actions>
              <Button variant="text" onClick={onClose}>
                Annuler
              </Button>

              <LoadingButton type="submit" loading={submitting}>
                Valider
              </LoadingButton>
            </Dialog.Actions>
          </form>
        )}
      </Form>
    </Dialog>
  );
}

MoveAllOrdersDialog.fragments = {
  orderState: gql`
    fragment MoveAllOrdersDialog_orderState on OrderState {
      id
      label
    }
  `,
};
